export const loading = {
    state: {
        photos: []
    },
    mutations: {
        SET_LOADING_STATUS(state, status) {
            state.loadingStatus = status
        },
        ADD_LOADING_PHOTO(state, photo){
            state.photos.push(photo)
        },
        REMOVE_LOADING_PHOTO(state, photosToRemove){
            for(const photoToRemove of photosToRemove) {
                const idx = state.photos.findIndex(photo => photo.id === photoToRemove)
                if(idx > -1) {
                    state.photos.splice(idx, 1)
                }
            }
        },
        SET_LOADING_PHOTO_DOCUMENT_TYPE(state, payload) {
            const idx = state.photos.findIndex(photo => photo.id === payload.id)
            state.photos[idx].documentTypeId = parseInt(payload.documentTypeId) || -1
        }
    },
    actions: {
        addLoadingPhoto({ commit }, image){
            commit('ADD_LOADING_PHOTO', {
                id: Date.now(),
                image,
                documentTypeId: null
            })
        },
        setLoadingPhotoDocumentType({ commit }, payload) {
            commit('SET_LOADING_PHOTO_DOCUMENT_TYPE', payload)
        },
        removeLoadingPhoto({ commit }, photosToRemove){
            commit('REMOVE_LOADING_PHOTO', photosToRemove)
        }
    },
    getters : {
        loadingPhotos: (state) => {
            return state.photos
        },
        loadingPhotosForApi: (state) => {
            return state.photos.map(photo => ({
                base64: photo.image,
                document_type_id: photo.documentTypeId
            }))
        }
    }
}
